import React from 'react';
import { Button } from './ui/Button';
import { Moon, Star } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-slate-900 pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-102">
      {/* Background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-103">
        <div className="absolute top-20 right-0 w-72 h-72 bg-indigo-500/10 rounded-full blur-3xl" data-id="element-104" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-amber-500/5 rounded-full blur-3xl" data-id="element-105" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-106">
        <div className="max-w-4xl mx-auto text-center" data-id="element-107">
          <div className="inline-flex items-center space-x-2 bg-slate-800/50 rounded-full px-4 py-1.5 mb-8 border border-slate-700/50 backdrop-blur-sm" data-id="element-108">
            <Moon className="w-4 h-4 text-amber-400" data-id="element-109" />
            <span className="text-sm font-medium text-slate-300" data-id="element-110">
              Protocolo Noche Tranquila
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight mb-12" data-id="element-111">
            Si se despierta a las 3AM… <br className="hidden sm:block" data-id="element-112" />
            <span className="text-amber-400" data-id="element-113">ya no improvises</span>
          </h1>

          <p className="text-xl sm:text-2xl text-slate-300 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-114">
            El protocolo de 14 noches para dormir sin pastillas.
            <br data-id="element-115" />
            Para adultos jóvenes y mayores de 65+: cuando el sueño se rompe,
            necesitas un sistema (no fuerza de voluntad).
          </p>

          <div className="flex flex-col items-center justify-center mb-28" data-id="element-116">
            <Button size="lg" onClick={() => {
            trackAddToCart();
            window.open('https://serenahora.com/checkouts/cn/hWNAGIgi5eoLQy7fxtnZF6np/es-us?_r=AQAB78Tf_A3qo8AB4PDHM7Dkkil08ZQWB39fMm0yNAND&auto_redirect=false&cart_link_id=Sf1RLc40&edge_redirect=true&preview_theme_id=183858233635&skip_shop_pay=true', '_blank');
          }} className="w-full sm:w-auto font-bold mb-3" data-id="element-117">
              Quiero el plan de 14 noches
            </Button>
            <div className="flex flex-col items-center gap-1.5" data-id="element-118">
              <p className="text-sm text-slate-400 flex items-center justify-center mb-1" data-id="element-119">
                <Star className="w-4 h-4 text-amber-400 mr-1.5 fill-amber-400" data-id="element-120" />
                Garantía de satisfacción 7 días (reembolso)
              </p>
              <p className="text-base font-semibold text-slate-200" data-id="element-121">
                Hoy $6.39 USD (≈ $112 MXN)
              </p>
              <p className="text-sm text-slate-400 font-medium" data-id="element-122">
                ⚡ Acceso de inmediato
              </p>
            </div>
          </div>

          <div className="mb-12" data-id="element-123">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 flex items-center justify-center gap-3" data-id="element-124">
              <span className="w-2.5 h-2.5 rounded-full bg-green-500 animate-pulse" data-id="element-125"></span>
              Testimonio real (25s)
            </h3>
            <div className="max-w-[280px] mx-auto rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-700/50 bg-slate-800 mb-12" data-id="element-126">
              <video src="https://cdn.magicpatterns.com/uploads/dEp5dLBppzSHUurmSzL3eb/fiverrgirl2.mp4" controls playsInline className="w-full h-auto aspect-[9/16] object-cover" data-id="element-127" />
            </div>

            <h3 className="text-xl sm:text-2xl font-bold text-white mb-6" data-id="element-128">
              Mensajes reales de clientes (WhatsApp)
            </h3>

            <div className="max-w-[320px] mx-auto rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-700/50" data-id="element-129">
              <img src="https://cdn.magicpatterns.com/uploads/9N11BxmQmfPTtCKwjUUC1d/wha3.jpg" alt="Testimonio de cliente por WhatsApp" className="w-full h-auto object-cover" data-id="element-130" />
            </div>
          </div>
        </div>

        <div className="relative max-w-4xl mx-auto mt-28 rounded-2xl overflow-hidden shadow-2xl shadow-black/50 border border-slate-800" data-id="element-131">
          <img src="https://cdn.magicpatterns.com/uploads/a3w8192NHbF4fMqzUfKyXt/heylloyd-image-1770947182596.png" alt="Mujer mayor leyendo el protocolo en una tablet en la cama" className="w-full h-auto object-cover" data-id="element-132" />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent opacity-60" data-id="element-133" />
        </div>
      </div>
    </section>;
}